import { Img } from './Img';
import { ImgProps } from '../types';

export const StaticLayersOnly = ({
    layers,
    deselect,
    handleImgLoad
}: {
    layers: ImgProps[];
    deselect: () => void;
    handleImgLoad: (id: string, img: HTMLImageElement | undefined) => void;
}): any => {
    return layers
        .filter((layer) => !layer.draggable)
        .map(({ src, ...layer }) => (
            <Img
                key={layer.id}
                src={src}
                onClick={deselect}
                onLoad={(img) => {
                    handleImgLoad(layer.id, img);
                }}
                listening={false}
                {...layer}
            />
        ));
};
